<template>
  <v-btn
    icon
    @click="() => changeSettingsDialogVisibility(true)"
  >
    <v-icon>mdi-settings</v-icon>
  </v-btn>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import navigateMixin from '../../mixins/navigate'

export default {
  methods: {
    ...mapMutations('common', ['changeSettingsDialogVisibility']),
  }
}
</script>
